import gql from 'graphql-tag';

const query = gql`
  query DailyTrackerMeal($id: Int!) {
    dailyTracker {
      meal(id: $id) {
        ... on SimpleDailyTrackerMeal {
          id
          name
          calories
          proteinGrams
          carbsGrams
          fatGrams
          fiberGrams
          portions
          imageUrl
          mealType
          loggedAt
          sourceType
          isFromBaseMeal
          isUserMeal
          isQuickMeal
          notes
        }
        ... on DailyTrackerMealWithProducts {
          id
          name
          calories
          proteinGrams
          carbsGrams
          fatGrams
          fiberGrams
          portions
          imageUrl
          mealType
          loggedAt
          sourceType
          sourceId
          isFromBaseMeal
          isUserMeal
          isQuickMeal
          baseMealId
          derivedMealsCount
          notes
          products {
            id
            productId
            name
            brand
            isUserProduct
            calories
            proteinGrams
            carbsGrams
            fatGrams
            fiberGrams
            baseAmount
            baseUnit
            measurement {
              measureId
              amount
              text
              unit
            }
          }
        }
      }
    }
  }
`;

export default query;
